export const isZppUserAlreadyApplied = (state) => state.entities.users.zppAlreadyApplied;
